import React from 'react'
import { Shield, CheckCircle2, AlertTriangle, KeyRound, Server, Cloud } from 'lucide-react'
import { env, isSupabaseConfigured, isDemoEnvironment } from '../../config/env'

export const AuthStatusView: React.FC = () => {
  const isConfigured = isSupabaseConfigured()
  const isDemo = isDemoEnvironment()

  return (
    <div>
      <div style={{ marginBottom: '1.5rem' }}>
        <h1 style={{ fontSize: '1.5rem', marginBottom: '0.2rem' }}>Diagnóstico de Acceso y Entorno (Solo Dev)</h1>
        <p style={{ color: 'var(--text-secondary)', fontSize: '0.85rem' }}>
          Monitor técnico disponible exclusivamente en modo desarrollo para verificar infraestructura y seguridad.
        </p>
      </div>

      {/* Estado del Entorno */}
      <div className="card">
        <div className="card-header">
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <Server size={16} style={{ color: 'var(--brand-red)' }} />
            <h2 className="card-title">Configuración de Entorno</h2>
          </div>
          <span className="badge badge-info">{env.appEnv}</span>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0.75rem', backgroundColor: 'var(--surface-subtle)', borderRadius: 'var(--radius-sm)', border: '1px solid var(--surface-border)' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <Cloud size={16} style={{ color: isConfigured ? 'var(--status-success-text)' : 'var(--status-warning-text)' }} />
              <span style={{ fontWeight: 500 }}>Backend Supabase (PostgreSQL / Auth)</span>
            </div>
            {isConfigured ? (
              <span className="badge badge-success">
                <CheckCircle2 size={13} />
                <span>Conectado</span>
              </span>
            ) : (
              <span className="badge badge-warning">
                <AlertTriangle size={13} />
                <span>Sin conectar (Modo local)</span>
              </span>
            )}
          </div>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0.75rem', backgroundColor: 'var(--surface-subtle)', borderRadius: 'var(--radius-sm)', border: '1px solid var(--surface-border)' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <Shield size={16} style={{ color: isDemo ? 'var(--brand-yellow)' : 'var(--text-secondary)' }} />
              <span style={{ fontWeight: 500 }}>Modo Demostración</span>
            </div>
            {isDemo ? (
              <span className="badge badge-yellow">Activo</span>
            ) : (
              <span className="badge badge-muted">Inactivo</span>
            )}
          </div>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0.75rem', backgroundColor: 'var(--surface-subtle)', borderRadius: 'var(--radius-sm)', border: '1px solid var(--surface-border)' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <KeyRound size={16} style={{ color: 'var(--status-success-text)' }} />
              <span style={{ fontWeight: 500 }}>Seguridad de claves en cliente</span>
            </div>
            <span className="badge badge-success">
              <CheckCircle2 size={13} />
              <span>Sin claves privilegiadas</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}
